/**
 * Platform detection utilities
 */

/**
 * Detects if the user is on a Mac platform
 * @returns {boolean} true if on Mac, false otherwise
 */
export const isMac = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  
  return navigator.platform.includes('Mac');
};

/**
 * Gets the appropriate keyboard shortcut text for new line
 * @returns {string} "Shift + Return" for Mac, "Shift + Enter" for other platforms
 */
export const getNewLineShortcut = (): string => {
  return isMac() ? 'Shift + Return' : 'Shift + Enter';
};
